import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteHardwareDescription,
  fetchHardwareDescriptions,
} from "../../../../store/slices/hardwareDescriptionSlice";
import { fetchHardware } from "../../../../store/slices/hardwareSlice";
import CommaConvert from "../../../../utils/CommaConvert";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import { getAllAssemblyInventory } from "../../../../store/slices/assemblyInventorySlice";

const HardwareEditAddOmAssigned = ({
  emp,
  hardwarePartsOp,
  setHardwarePartsOp,
  assignedGroup,
  assignedGroupId,
  isViewOnly = false,
}) => {
  const dispatch = useDispatch();
  const USAComma = CommaConvert();
  const currency = useCurrencySymbol();
  const { inventory } = useSelector((state) => state.assemblyInventory);

  useEffect(() => {
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchHardware());
    dispatch(getAllAssemblyInventory());
  }, [dispatch]);

  const [fetchedHardwareData, setfetchedHardwareData] = useState([]);

  useEffect(() => {
    const getGroupId = (value) => {
      if (!value) return "";
      if (typeof value === "object") {
        return String(
          value?._id ||
            value?.id ||
            value?.value ||
            value?.groupid?._id ||
            value?.groupid?.id ||
            value?.groupid ||
            value?.groupId?._id ||
            value?.groupId?.id ||
            value?.groupId ||
            ""
        ).trim();
      }
      return String(value).trim();
    };

    const targetGroupId = getGroupId(assignedGroupId) || getGroupId(assignedGroup);

    const filteredInventory =
      targetGroupId
        ? (inventory || []).filter((item) => {
            const inventoryGroupId = getGroupId(item?.groupid) || getGroupId(item?.groupId) || getGroupId(item?.group);
            return inventoryGroupId && inventoryGroupId === targetGroupId;
          })
        : [];
    
    const newhardwareRows = filteredInventory?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    })) ?? [];

    setfetchedHardwareData(newhardwareRows);
  }, [inventory, assignedGroup, assignedGroupId]);

  const handleAddHardware = () => {
    if (isViewOnly) return;
    if (hardwarePartsOp.length >= 15) return;
    setHardwarePartsOp([
      ...hardwarePartsOp,
      {
        assemblepartdescription: "",
        partno: "",
        quantity: "",
        unitprice: "",
        totalprice: "",
      },
    ]);
  };

  const handleRemoveHardware = () => {
    if (isViewOnly) return;
    if (hardwarePartsOp.length > 1) {
      const newHardware = [...hardwarePartsOp];
      newHardware.pop();
      setHardwarePartsOp(newHardware);
    }
  };

  const handlehardwareInputChange = (index, key, value) => {
    if (isViewOnly) return;
    const updated = [...hardwarePartsOp];
    if (key === "assemblepartdescription") {
      const selectedPart = fetchedHardwareData?.find(
        (item) => item.assemblepartdescription === value
      );
      if (selectedPart) {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: selectedPart.assemblepartdescription,
          partno: selectedPart.partnumber,
          unitprice: selectedPart.unitprice.toString(),
          totalprice:
            updated[index].quantity && updated[index].quantity !== ""
              ? (
                  selectedPart.unitprice * Number(updated[index].quantity)
                ).toFixed(2)
              : "",
        };
      } else {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: value,
          partno: "",
          unitprice: "",
          totalprice: "",
        };
      }
    } else if (key === "quantity") {
      const quantity = Number(value);
      const unitprice = Number(updated[index].unitprice || 0);

      updated[index] = {
        ...updated[index],
        quantity: value,
        totalprice:
          !isNaN(quantity) && quantity !== 0
            ? (unitprice * quantity).toFixed(2)
            : "0.00",
      };
    } else {
      updated[index][key] = value;
    }
    setHardwarePartsOp(updated);
  };

  const handleClick = () => {
    if (hardwarePartsOp.length > 0) {
      const lastItem = hardwarePartsOp[hardwarePartsOp.length - 1];
      dispatch(deleteHardwareDescription(lastItem?._id));
    }
  };

  return (
    <div>
      <div className="mainhardwarekdiv w-full">
        <div className="w-full max-h-[14rem] overflow-auto h-full justify-center pb-2">
          <div className="sticky top-0 flex flex-col w-full z-20">
            <div className="w-full flex flex-col">
              <div className="head flex text-center bg-blue-500 text-white text-[11px]">
                <div className=" border p-1 w-14  break-all whitespace-normal">
                  Sr.No
                </div>
                <div className=" border w-44 pt-1  break-all whitespace-normal">
                  Part Name
                </div>
                <div className=" border w-20  break-all whitespace-normal  p-1">
                  Part No
                </div>
                <div className=" border w-24  break-all whitespace-normal p-1">
                  Quantity
                </div>
                <div className=" border w-24  break-all whitespace-normal p-1">
                  Unit Price ({currency})
                </div>
                <div className=" border w-36  break-all whitespace-normal p-1">
                  Total Price ({currency})
                </div>
              </div>
              <div className="head flex text-center bg-blue-500  text-white text-[11px]">
                <div className=" border p-1 w-14  break-all whitespace-normal"></div>
                <div className=" border w-44 pt-1  break-all whitespace-normal">
                  Total
                </div>
                <div className=" border w-20  break-all whitespace-normal  p-1">
                  {" "}
                </div>
                <div className=" border w-24  break-all whitespace-normal p-1"></div>
                <div className=" border w-24  break-all whitespace-normal p-1">
                  {" "}
                </div>
                <div className=" border w-36  break-all whitespace-normal p-1">
                  {USAComma(
                    hardwarePartsOp?.reduce((sum, item) => {
                      return sum + Number(item.totalprice);
                    }, 0)
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="w-full">
            {hardwarePartsOp.map((row, index) => (
              <React.Fragment key={index}>
                <div className="flex items-center text-center w-full text-[11px]">
                  <div className="w-full">
                    <div className="flex">
                      <div className="border w-14 p-1">{index + 1}</div>
                      <div className=" border w-44 break-all whitespace-normal">
                        <select
                          name="assemblepartdescription"
                          value={row.assemblepartdescription || ""}
                          disabled={isViewOnly}
                          onChange={(e) =>
                            handlehardwareInputChange(
                              index,
                              "assemblepartdescription",
                              e.target.value
                            )
                          }
                          className={`outline-none border-none text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-gray-100"}`}
                        >
                          <option value="" disabled hidden>
                            {row.assemblepartdescription ? "" : "Select"}
                          </option>
                          {fetchedHardwareData?.map((option) => {
                            const isAlreadySelected = hardwarePartsOp.some(
                              (row, i) =>
                                row.assemblepartdescription ===
                                  option.assemblepartdescription && i !== index
                            );
                            if (isAlreadySelected) return null;
                            return (
                              <option
                                key={option._id}
                                value={option.assemblepartdescription}
                              >
                                {option.assemblepartdescription}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className=" border w-20 p-1  break-all whitespace-normal">
                        {row.partno || " "}
                      </div>

                      <div className=" border w-24 p-1 break-all whitespace-normal">
                        <input
                          type="text"
                          placeholder="Enter quantity"
                          value={row.quantity || ""}
                          disabled={isViewOnly}
                          onChange={(e) => {
                            if (isViewOnly) return;
                            let value = e.target.value;
                            if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                              handlehardwareInputChange(
                                index,
                                "quantity",
                                value
                              );
                            }
                          }}
                          onKeyDown={(e) => {
                            if (
                              !(
                                (e.key >= "0" && e.key <= "9") ||
                                e.key === "." ||
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "ArrowLeft" ||
                                e.key === "ArrowRight" ||
                                e.key === "Tab"
                              )
                            ) {
                              e.preventDefault();
                            }
                          }}
                          className={`outline-none border-none break-all whitespace-normal text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        />
                      </div>

                      <div className=" border p-1 w-24 break-all whitespace-normal">
                        {USAComma(row.unitprice) || " "}
                      </div>

                      <div className=" border p-1 w-36 break-all whitespace-normal">
                        {USAComma(row.totalprice) || " "}
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}

            {!(
              (emp.fullName === "Self" ||
                emp.customRole[0] === "project manager" ||
                emp.customRole[0] === "operations") &&
              emp?.Assignedperson?.projecttracktaskStatus === "submit"
            ) && (
              <>
                {emp.Assignedperson?.operationaction !== "reject" && (
                  <div className="flex justify-between px-2 pt-1">
                    <button
                      className={`shadow-xl rounded-md p-1 ${isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none text-[#9ca3af]" : ""}`}
                      onClick={handleAddHardware}
                      disabled={isViewOnly || hardwarePartsOp.length >= 15}
                    >
                      <AddIcon />
                    </button>
                    <button
                      className={`shadow-xl rounded-md p-1 ${isViewOnly ? "opacity-60 cursor-not-allowed pointer-events-none text-[#9ca3af]" : ""}`}
                      onClick={() => {
                        if (isViewOnly) return;
                        handleRemoveHardware();
                        handleClick();
                      }}
                      disabled={isViewOnly || hardwarePartsOp.length <= 1}
                    >
                      <RemoveIcon />
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HardwareEditAddOmAssigned;
